import { Component } from '@angular/core';

@Component({
  selector: 'presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss'],
  standalone: false
})
export class PresentationComponent { }
